import {
  MileageListAddressSequence,
  MileageListAddressSequenceNode,
  MileageListItem,
} from "../../../../common/services/mileage/list/mileage-list";
import MileageListingAddressSequence, {
  MileageListingAddressSequenceNode,
} from "./types/mileage-listing-address-sequence";
import MileageListingStatus from "./types/mileage-listing-status";
import MileageListingVehicleType from "./types/mileage-listing-vehicle-type";
import MileageListingItem from "./types/mileage-listing-item";
import VehicleType from "../../../../common/types/vehicle-type";
import MileageStatus from "../../../../common/types/mileage-status";

const createAddressSequenceNode = (
  node: MileageListAddressSequenceNode,
): MileageListingAddressSequenceNode => {
  return {
    displayName: node.displayName,
    lat: node.lat,
    lon: node.lon,
  };
};

const createAddressSequence = (
  listAddressSequence: MileageListAddressSequence,
): MileageListingAddressSequence => {
  const sequence: MileageListingAddressSequenceNode[] =
    listAddressSequence.seq.map(createAddressSequenceNode);

  return {
    seq: sequence,
  };
};

const createStatus = (state: MileageStatus): MileageListingStatus => {
  switch (state) {
    case MileageStatus.ACCEPTED:
      return MileageListingStatus.ACCEPTED;
    case MileageStatus.DELEGATION_CREATED:
      return MileageListingStatus.DELEGATION_CREATED;
    case MileageStatus.PENDING:
      return MileageListingStatus.PENDING;
    case MileageStatus.REJECTED:
      return MileageListingStatus.REJECTED;
  }
};

const createVehicleType = (type: VehicleType): MileageListingVehicleType => {
  switch (type) {
    case VehicleType.CAR_GT_900CM3:
      return MileageListingVehicleType.CAR_GT_900CM3;
    case VehicleType.CAR_LE_900CM3:
      return MileageListingVehicleType.CAR_LE_900CM3;
    case VehicleType.COMPANY_OWNED:
      return MileageListingVehicleType.COMPANY_OWNED;
    case VehicleType.MOPED:
      return MileageListingVehicleType.MOPED;
    case VehicleType.MOTORCYCLE:
      return MileageListingVehicleType.MOTORCYCLE;
  }
};

const createItem = (item: MileageListItem): MileageListingItem => {
  return {
    addressSeq: createAddressSequence(item.addressSeq),
    distance: item.distance,
    humanId: item.humanId,
    uuid: item.uuid,
    mileageDate: item.mileageDate,
    status: createStatus(item.status),
    vehicleType: createVehicleType(item.vehicleType),
    workerCompanyUuid: item.workerCompanyUuid,
    workerUuid: item.workerUuid,
    workerName: item.workerName,
    workerPhone: item.workerPhone,
    cardNumber: item.cardNumber,
    cargoCompanyName: item.cargoCompanyName,
    mileageNumber: item.mileageNumber,
    osrmDistance: item.osrmDistance,
    acceptedDistance: item.acceptedDistance,
  };
};

const create = (listItems: MileageListItem[]): MileageListingItem[] => {
  const listingItems: MileageListingItem[] = listItems.map(createItem);

  return listingItems;
};

const mileageListingItemFactory = {
  create,
};

export default mileageListingItemFactory;
